import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { webUI, webUIBaseUrl } from "../endpoints";
// Define a service using a base URL and expected endpoints
export const privateLibraryService = createApi({
  reducerPath: "privateLibraryService",
  baseQuery: fetchBaseQuery({ baseUrl: webUIBaseUrl }),
  tagTypes: ["privateLibrary"],
  endpoints: (builder) => ({
    getLibraryByCategoryId: builder.mutation({
      query(body) {
        return {
          url: `${webUI.privateLibraryController.getLibraryByCategoryId}/category/${body.libraryCategoryId}?page=${body.page}&size=${body.size}&sort=${body.sort}`,
          method: "GET",
          // headers: { Authorization: `Bearer ${body.token}`},
          body: body.payload,
        };
      },
    }),
    uploadPdf: builder.mutation({
      query(body) {
        return {
          url: `${webUI.privateLibraryController.upload}?libraryCategoryId=${body.libraryCategoryId}`,
          method: "POST",
          // headers: { Authorization: `Bearer ${body.token}`},
          body: body.file,
        };
      },
    }),
    deletePdf: builder.mutation({
      query(body) {
        return {
          url: `${webUI.privateLibraryController.deletePdf}/${body.id}`,
          method: "DELETE",
        };
      },
    }),
    getLibraryById: builder.mutation({
      query(body) {
        return {
          url: `${webUI.privateLibraryController.getLibraryById}/${body.id}`,
          method: "GET",
          // headers: { Authorization: `Bearer ${body.token}`},
        };
      },
    }),
    downloadPdf: builder.mutation({
      query(body) {
        return {
          url: `${webUI.privateLibraryController.downloadPdf}/${body.recordId}/download`,
          method: "GET",
          // headers: { Authorization: `Bearer ${body.token}`},
        };
      },
    }),
  }),
});
export const {
  useGetLibraryByCategoryIdMutation,
  useGetLibraryByIdMutation,
  useUploadPdfMutation,
  useDownloadPdfMutation,
  useDeletePdfMutation,
} = privateLibraryService;
